import React from 'react';
import { useOutletContext } from 'react-router-dom';

import { ROUTE } from '~/app/routes';
import { PaginationWrapper, SectionHeader } from '~/components';
import { useNavigate } from '~/lib/navigation';
import { Inner } from '~/styles';

import { LoanProps } from './Loan';
import { handleFetchPayments, paymentColumns, paymentFilter } from './Payment/Overview';

export const PageLoanPayments: React.FC = () => {
  const navigate = useNavigate();
  const { loan } = useOutletContext<LoanProps>();

  if (!loan?.id) {
    return null;
  }

  return (
    <>
      <SectionHeader text="Payments" />

      <Inner p={0} pb={24}>
        <PaginationWrapper
          tableId="loanPayments"
          fetch={(o) => handleFetchPayments({ ...o, loanId: loan.id }, navigate)}
          columns={paymentColumns}
          filter={paymentFilter}
          rowClick={(row) => {
            navigate(`${ROUTE.LOANS}/payments/edit/${row.original.id}`);
          }}
        />
      </Inner>
    </>
  );
};
